import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/mediabook/mediabook/src/templates/Standalone.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`General information`}</h1>
    <p><a parentName="p" {...{
        "href": "https://www.bppe.ca.gov/"
      }}>{`Bureau of Private Postsecondary Education`}</a></p>
    <p><a parentName="p" {...{
        "href": "http://care.com"
      }}>{`Care.com`}</a>{` (National network of childcare providers)`}</p>
    <p><a parentName="p" {...{
        "href": "http://www.childrenscouncil.org/"
      }}>{`Children’s Council`}</a>{` (Childcare in the Bay Area)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.clippercard.com/"
      }}>{`Clipper Card`}</a>{` (Public Transportation in the Bay Area)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.coveredca.com/"
      }}>{`Covered California`}</a>{` (California’s Health Insurance Exchange)`}</p>
    <p><a parentName="p" {...{
        "href": "https://www2.ed.gov/policy/gen/guid/fpco/ferpa/index.html"
      }}>{`Family Educational Rights and Privacy Act (FERPA)`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://github.com/Product-College-Courses/"
      }}>{`GitHub`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.healthcare.gov/"
      }}>{`Healthcare.gov`}</a>{` (National Healthcare Exchange)`}</p>
    <p><a parentName="p" {...{
        "href": "http://makeschool.org"
      }}>{`Make School`}</a></p>
    <p><a parentName="p" {...{
        "href": "https://www.wscuc.org/content/incubation-policy"
      }}>{`Make School’s Incubation Policy`}</a>{` (WSCUC
Accreditation Information)`}</p>
    <p><a parentName="p" {...{
        "href": "http://slack.com"
      }}>{`Slack`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      